var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStripe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 17,
    viewBox: "0 0 39 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0003 8.80346C39.0003 6.03013 37.657 3.8418 35.0895 3.8418C32.5112 3.8418 30.9512 6.03013 30.9512 8.78179C30.9512 12.0426 32.7928 13.6893 35.4362 13.6893C36.7253 13.6893 37.7003 13.3968 38.437 12.9851V10.8185C37.7003 11.1868 36.8553 11.4143 35.7828 11.4143C34.732 11.4143 33.8003 11.046 33.6812 9.76762H38.9787C38.9787 9.62679 39.0003 9.06346 39.0003 8.80346ZM33.6487 7.77429C33.6487 6.55013 34.3962 6.04096 35.0787 6.04096C35.7395 6.04096 36.4437 6.55013 36.4437 7.77429H33.6487Z",
    fill: "#6772E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7691 3.8418C25.7074 3.8418 25.0249 4.34013 24.6457 4.6868L24.5049 4.01513H22.1216V16.6468L24.8299 16.0726L24.8407 13.0068C25.2307 13.2885 25.8049 13.6893 26.7582 13.6893C28.6974 13.6893 30.4632 12.1293 30.4632 8.69513C30.4524 5.55346 28.6649 3.8418 26.7691 3.8418ZM26.1191 11.306C25.4799 11.306 25.1007 11.0785 24.8407 10.7968L24.8299 6.77763C25.1116 6.46346 25.5016 6.24679 26.1191 6.24679C27.1049 6.24679 27.7874 7.35179 27.7874 8.77096C27.7874 10.2226 27.1157 11.306 26.1191 11.306Z",
    fill: "#6772E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1142 2.61713V0.417969L18.395 0.992135V3.20213L21.1142 2.61713Z",
    fill: "#6772E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1142 4.02441H18.395V13.5036H21.1142V4.02441Z",
    fill: "#6772E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4811 4.82575L15.3078 4.02409H12.9678V13.5032H15.6761V7.07908C16.3153 6.24492 17.3986 6.39659 17.7344 6.51575V4.02409C17.3878 3.89409 16.1203 3.65576 15.4811 4.82575Z",
    fill: "#6772E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0643 1.6748L7.42099 2.23814L7.41016 10.9156C7.41016 12.519 8.61266 13.6998 10.216 13.6998C11.1043 13.6998 11.7543 13.5373 12.1118 13.3423V11.1431C11.7652 11.284 10.0535 11.7823 10.0535 10.179V6.33313H12.1118V4.02564H10.0535L10.0643 1.6748Z",
    fill: "#6772E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.74083 6.77763C2.74083 6.35513 3.0875 6.19263 3.66166 6.19263C4.48499 6.19263 5.52499 6.44179 6.34832 6.88596V4.34013C5.44916 3.98263 4.56083 3.8418 3.66166 3.8418C1.4625 3.8418 0 4.99013 0 6.90763C0 9.89762 4.11666 9.42096 4.11666 10.7101C4.11666 11.2085 3.68333 11.371 3.07666 11.371C2.1775 11.371 1.02917 11.0026 0.119166 10.5043V13.0826C1.12667 13.5159 2.145 13.7001 3.07666 13.7001C5.32999 13.7001 6.87916 12.5843 6.87916 10.6451C6.86832 7.41679 2.74083 7.99096 2.74083 6.77763Z",
    fill: "#6772E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.9ceb29f2.svg";
export { ForwardRef as ReactComponent };